/**
 * Create the store with dynamic reducers
 */

 import { configureStore } from "@reduxjs/toolkit";
 import type { StoreEnhancer } from "@reduxjs/toolkit";
 import { createInjectorsEnhancer } from "redux-injectors";
 import createSagaMiddleware from "redux-saga";
 
 import { createReducer } from "./reducers";
 
 export function configureAppStore() {
   const reduxSagaMonitorOptions = {};
   const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
   const { run: runSaga } = sagaMiddleware;
 
   const enhancers = [
     createInjectorsEnhancer({
       createReducer,
       runSaga,
     }),
   ] as unknown as StoreEnhancer[];
 
   return configureStore({
     reducer: createReducer(),
     middleware: (getDefaultMiddleware: any) =>
       getDefaultMiddleware().concat(sagaMiddleware),
     devTools: process.env.NODE_ENV !== "production",
     enhancers,
   });
 }
 